export const isBrowser =
    typeof document !== "undefined" && typeof process === "undefined";
